import { isAxiosError } from 'axios';
import { ApiErrorResponse } from '../types/types';

const ERROR_MESSAGES = {
  server: '500 - Internal Server Error',
} as const;

export const parseApiError = (error: unknown): string => {
  if (!isAxiosError<ApiErrorResponse>(error)) {
    return ERROR_MESSAGES.server;
  }

  const { data } = error.response ?? {};
  if (!data?.detail) {
    return ERROR_MESSAGES.server;
  }

  return data.detail;
};
